import { defineAsyncComponent } from 'vue'
export default {
  base: defineAsyncComponent(() => import("/app/layouts/base.vue").then(m => m.default || m)),
  data: defineAsyncComponent(() => import("/app/layouts/data.vue").then(m => m.default || m)),
  moderation: defineAsyncComponent(() => import("/app/layouts/moderation.vue").then(m => m.default || m)),
  publisher: defineAsyncComponent(() => import("/app/layouts/publisher.vue").then(m => m.default || m))
}